import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import Randomizer from '../../components/Randomizer/Randomizer';
import { setPortableMode } from '../../containers/App/actions';
import { selectPortableMode } from '../../containers/App/selectors';
import { resetDocumentZoom } from '../../components/ZoomApp/zoomDocument';
import V2Icon from './V2Icon';
import V2AutopasteSwitch from './V2AutopasteSwitch';

const V2WorkspaceTools: React.FC = () => {
  const dispatch = useDispatch();
  const portableMode = useSelector(selectPortableMode);

  const handlePortableToggle = React.useCallback(() => {
    const nextPortableMode = !portableMode;

    if (portableMode) {
      resetDocumentZoom();
    }

    dispatch(setPortableMode(nextPortableMode));
  }, [dispatch, portableMode]);

  return (
    <div className="workspace-tools" aria-label="Инструменты">
      <Randomizer variant="chip" />
      <V2AutopasteSwitch />
      <button
        type="button"
        className={classNames('workspace-tool workspace-tool--portable', {
          'workspace-tool--active': portableMode,
        })}
        onClick={handlePortableToggle}
        aria-pressed={portableMode}
        aria-label={portableMode ? 'Выйти из портативного режима' : 'Портативный режим'}
        title={portableMode ? 'Выйти из портативного режима' : 'Портативный режим'}
      >
        <V2Icon name="compact" />
      </button>
    </div>
  );
};

export default V2WorkspaceTools;
